import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";

// Others File
import RulesCard from "./RulesCard";
import useFetch from "../../context/useFetch";
import { toast } from "react-toastify";

const Rules = () => {
  const [dataList, setDataList] = useState({ results: [] });
  const getRuleList = useFetch({
    method: "get",
    noHeader: true,
    url: `Rule_Service`,
    params: {
      pageSize: 150,
    },
    trigger: true,
    setter: setDataList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="rules" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">قوانین و مقررات</p>
        <div className="border rounded-lg mt-8 border-mygray-300 py-8 px-4">
          <div className="border-r-4 md:col-span-2 border-mygray-300 px-4">
            <span className="text-sm md:text-base font-bold text-mygray-700">
              کاربر گرامی شما می‌توانید قوانین و مقررات بیمه‌ای را در این
              بخش دریافت نمایید.
            </span>
          </div>
          <div className="mt-8  grid md:grid-cols-4 gap-8 md:gap-12 mx-4">
            {dataList.results.map((item, index) => {
              return [<RulesCard item={item} key={index} />];
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Rules;
